import React, { Component } from 'react'
import Icon from './Icon'
import Tooltip from '@sidx/tooltips'

export default class Help extends Component {

  renderContent() {
    return (
      <div className="help-content">
        <div className="help-title">Help</div>
        {this.props.children}
      </div>
    )
  }

  render() {
    return (
      <div className="help-container">
        <Tooltip content={this.renderContent()}>
          <Icon className="help" icon="question-circle-o" />
        </Tooltip>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/util/Help.js